import { useEffect, useRef } from 'react';
import { Content, JSONContent, JSONData, JSONEditor as SvelteJSONEditor } from 'svelte-jsoneditor/dist/jsoneditor.js';

// The `svelte-jsoneditor` copy that resolves here has no `svelte` dependency in its
// pnpm scope, so TypeScript falls back to a degenerate `SvelteComponentTyped` whose
// constructor is typed as taking 0 arguments. At runtime the Svelte 4 component does
// accept `{ target, props }`, so we re-type the constructor here (types only).
const SvelteJSONEditorCtor = SvelteJSONEditor as unknown as new (options: {
  target: Element;
  props?: { content?: Content };
}) => SvelteJSONEditor;

const JSONEditor: React.FC<{
  value: string;
  onChange: (newContent: string | JSONData) => void;
}> = props => {
  const { value, onChange } = props;
  const refContainer = useRef<HTMLDivElement>(null);
  const refEditor = useRef<SvelteJSONEditor | null>(null);
  const refContent = useRef<JSONContent>({ text: undefined, json: value });

  useEffect(() => {
    if (refContainer.current) {
      // create editor
      refEditor.current = new SvelteJSONEditorCtor({
        target: refContainer.current,
        props: {
          content: refContent.current
        }
      });
    }

    return () => {
      // destroy editor
      if (refEditor.current) {
        refEditor.current.destroy();
        refEditor.current = null;
      }
    };
  }, []);

  // update props
  useEffect(() => {
    if (refEditor.current) {
      refEditor.current.updateProps({
        ...props,
        onChange: (newContent: Content) => {
          if ('text' in newContent && newContent.text) {
            try {
              onChange(JSON.parse(newContent.text));
            } catch {
              console.error('Invalid JSON, value not saved');
            }
          } else if ('json' in newContent && newContent.json) {
            onChange(newContent.json);
          }
        }
      });
    }
  }, [props, onChange]);

  return <div className="svelte-jsoneditor-react" ref={refContainer}></div>;
};

export default JSONEditor;
